<template>
  <el-card class="form-section" shadow="never" :body-style="bodyStyle">
    <form-section-header
      v-if="title || description"
      :title="title || ''"
      :description="description"
      :is-changed="isChanged"
    >
      <template slot="controls">
        <slot name="controls"></slot>
      </template>
    </form-section-header>

    <div v-if="separator" class="separator"></div>
    <div class="content">
      <slot></slot>
    </div>
  </el-card>
</template>

<script>
import FormSectionHeader from '@/common/components/form/FormSectionHeader'

export default {
  name: 'FormSection',
  components: { FormSectionHeader },
  props: {
    title: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: false
    },
    separator: {
      type: Boolean,
      required: false,
      default: false
    },
    isChanged: {
      type: Boolean,
      required: false,
      default: false
    },
    bodyStyle: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style scoped>
.form-section {
  border: 1px solid #dbdee7;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  margin-bottom: 20px;
}
.separator {
  margin: 20px -20px;
  border-top: 1px solid #dbdee7;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/FormSection.vue